const { createSlice } = require('@reduxjs/toolkit')
let id = localStorage.getItem("user")
const initialStateData = {
  user: id
}
const AppData = createSlice({
  name: 'AppData',
  initialState: initialStateData,
  reducers: {
    getToken: (state, action) => {
      state = action.payload
    }
  }
})

export const { getToken } = AppData.actions;
export default AppData.reducer;